import { useEffect, useState } from 'react'

export const useDebouncedValue = <T>(value: T, delay = 100) => {
  const [val, setVal] = useState(value)

  useEffect(() => {
    const t = setTimeout(() => {
      setVal(value)
    }, delay)

    return () => {
      clearTimeout(t)
    }
  }, [delay, value])

  return val
}
